import React, { useState, useEffect } from "react";
import axios from "../axios";
import Select from "react-select";



function DropdownWithFetchApi({ name, value, onChange, apiUrl }) {
  // console.log("apiUrl main", apiUrl);
  const headers = {
    Authorization: "Bearer " + localStorage.getItem("@token"),
  };
  const [options, setOptions] = useState([]);

  useEffect(() => {
    // Fetch music fields from the API
    axios.get(apiUrl, { headers }).then((response) => {
      // setOptions(response.data);

      const formattedOptions = response.data.map((option) => ({
        value: option.id,
        label: name === "creator_id" ? option.email : option.name,
      }));
      setOptions(formattedOptions);

      // Auto-select creator_id based on localStorage email
      if (name === "creator_id" && (value == null || value === "")) {
        const userEmail = localStorage.getItem("@email");
        const matchedOption = formattedOptions.find(
          (opt) => opt.label === userEmail
        );
        if (matchedOption) {
          onChange({
            target: { name: "creator_id", value: matchedOption.value },
          });
        }
      }
    });
  }, [apiUrl]);

  return (
    // <select name={name} value={value} onChange={onChange}>
    //   <option key={null} value={null}>
    //     Select Below
    //   </option>
    //   {options.map((option) => (
    //     <option key={option.id} value={option.name}>
    //       {option.name}
    //       {/* {name === "creator_id" ? option.email : option.name} */}
    //     </option>
    //   ))}
    // </select>
    <Select
        options={options}
        // value={
        //   name === "creator_id" || name === "category_id" || name === "tag_ids"
        //     ? options.find((opt) => opt.value === value)
        //     : options.find((opt) => opt.label === value)
        // }
        value={
          name === "tag_ids"
            ? options.filter((opt) =>
                Array.isArray(value)
                  ? value.includes(opt.value)
                  : String(value).split(",").map((v) => Number(v.trim())).includes(opt.value)
              )
            : name === "creator_id" || name === "category_id"
              ? options.find((opt) => opt.value === value)
              : options.find((opt) => opt.label === value)
        }
        // onChange={(selected) =>
        //   onChange({ target: { name: name, value: selected?.value || "" } })
        // }
        onChange={(selected) =>
          onChange({
            target: {
              name: name,
              value: name === "tag_ids"
                ? selected?.map((s) => s.value) || []
                : selected?.value || "",
            },
          })
        }
        isClearable
        isSearchable
        isMulti={name === "tag_ids"}
        styles={{
          container: (base) => ({
            ...base,
            maxWidth: "100%",
            margin: "2px",
          }),
          control: (base) => ({
            ...base,
            minHeight: "30px",
            fontSize: "12px",
          }),
          singleValue: (base) => ({
            ...base,
            fontSize: "12px",
          }),
          option: (base) => ({
            ...base,
            fontSize: "12px",
          }),
          input: (base) => ({
            ...base,
            fontSize: "12px",
          }),
        }}
      />
    );
}

export default DropdownWithFetchApi;

